import { SERVER } from '@/constants/servers';
import fetch from '@/lib/fetch';

// region 判断当前是什么类型的平台; 从学习平台 src/config/constants.ts 抄过来的

const CLIENT_TYPE = {
  'xigua-web': 'WEB_CLIENT',
  'xigua-scratch': 'SCRATCH_CLIENT',
  'xigua-python': 'PYTHON_CLIENT',
};
const CURRENT_CLIENT = (window.XiguaElectronBridge && window.XiguaElectronBridge.appName) || 'xigua-web';
const CURRENT_CLIENT_TYPE = CLIENT_TYPE[CURRENT_CLIENT] || CURRENT_CLIENT;

// endregion

/**
 * @typedef ICurrentCourseResponse 当前课程信息, 抄至 fe-study 的 src/api/next/courseMap.ts
 * @property {boolean} isDropout 是否是退课了的学生
 * @property {number} coursesCount 总系统课数量。数量为1表示基础班
 * @property {boolean} isPreLectureLearned 新人任务是否已经学习了
 * @property {string} curriculumLineName 主题名
 * @property {string} curriculumCatalogName 单元名字
 * @property {string} clazzOid 班级ID
 * @property {string} curriculumCatalogOid 单元版本ID
 * @property {string} courseTemplateOid 课程模板ID
 * @property {number} curriculumCatalogSequence 主题序号
 * @property {number} unlockedCoursesCount 当前解锁系统课程的数量
 * @property {number} curriculumLineId 教材Id
 * @property {boolean} isPreTransferred 是否都是预调期
 */

/**
 * 获取当前学生的课程情况、可以用于判断当前学生是否购买课程等等
 * @return {Promise.<ICurrentCourseResponse>}
 */
export function getCurrentCourse() {
  return fetch(`${SERVER}/current_course?businessTag=${CURRENT_CLIENT_TYPE}`, {
    xFrom: 'im',
  }, {
    method: 'post',
  });
}
